import styled, { DefaultTheme } from 'styled-components';

interface TagProps {
  $status?: string;
  $transactionType?: string;
}

const getStatusColorFromTheme = (theme: DefaultTheme, status: string) => {
  switch (status) {
    case 'published':
      return theme.statusPublicPublished;
    case 'has_offers':
      return theme.statusPublicPublished;
    case 'closed':
      return theme.statusPublicClosed;
    case 'completed':
    case 'partially_completed':
      return theme.statusPublicCompleted;
    case 'cancelled':
      return theme.statusPublicCancelled;
    case 'unsuccessful':
      return theme.statusPublicUnsuccessful;
    default:
      return theme.statusPublicUnpublished;
  }
};

const getTransactionTypeColorFromTheme = (
  theme: DefaultTheme,
  type: string
) => {
  switch (type) {
    case 'purchase':
      return theme.transactionPurchase;
    case 'reservation':
      return theme.transactionReservation;
    case 'dynamic_purchase':
      return theme.transactionDynamicPurchase;
    default:
      return theme.brand01;
  }
};

export const StatusTag = styled('span')<TagProps>`
  padding: 3px 12px;
  border-radius: 12px;
  color: ${({ theme }) => theme.white};
  font-size: 15px;
  font-weight: 500;
  background-color: ${({ theme, $status }) =>
    $status
      ? getStatusColorFromTheme(theme, $status)
      : theme.statusPublicUnpublished};
`;

export const TransactionTypeTag = styled('span')<TagProps>`
  padding: 3px 12px;
  border-radius: 13px;
  font-size: 15px;
  font-weight: 500;
  border: 1px solid
    ${({ theme, $transactionType }) =>
      $transactionType
        ? getTransactionTypeColorFromTheme(theme, $transactionType)
        : theme.brand01};
  background-color: transparent;
`;
